<div class="error-container">
    <div class="error-card">
        <p class="error-status">{{title ? title : "Error!"}}<p>
        <p class="error-title">Oops!</p>
        <p class="mt-4 error-description" [innerHtml]="description ? description : '' "></p>
        <button mat-flat-button class="btn-large btn-primary mt-30" (click)="navigateTo()">Back to Login</button> 
    </div>
</div>